{
  "404": {
    "content": "Apologies, the page you are looking for could not be found."
  },
  "permissions": {
    "title": "You don’t have permission to view this page",
    "content": "If you believe you should, please contact your administrator."
  },
  "homeLink": "Go home",
  "previousLink": "Previous page",
  "loadingPage": "Checking your permissions, this will only take a moment...",
  "suspenseLoading": "Preparing your experience, this will only take a moment..."
}
